// extracted by mini-css-extract-plugin
export default {"anim":"style_anim__1vEAg"};